import Api from "../../service";
import Swal from "sweetalert2";

const handleGenerateUuid = async (type,accessToken) => {
    try {
        const response = await Api.post('/api/v1/Providers/GenUuidV2', {request_type:type,callback_url:"https://venesh.ir"},{
            headers:{
                "Authorization": `Bearer ${accessToken}`
            }
        });
        if(response&&!response.hasError){

            return response.data.uuid;
        }else {

            Swal.fire({
                text: response.message,
                title: "ناموفق",
                icon: 'error',
                backdrop:true,
                focusConfirm:false,
                showCancelButton: false,
                confirmButtonColor: '#d51e3e',
                confirmButtonText:'تلاش مجدد',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,


            }).then((result) => {
                handleGenerateUuid(type,accessToken)
            });

            throw new Error(response.message)
        }
    } catch (error) {
        console.log(error)

    }finally {

    }
};
export default handleGenerateUuid;